import _classCallCheck from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/neelrao/Projects/citycraft/client/node_modules/@babel/runtime/helpers/esm/createClass";

var EDictionary =
/*#__PURE__*/
function () {
  function EDictionary(ID_PROPERTY_NAME) {
    _classCallCheck(this, EDictionary);

    this.ID_PROPERTY_NAME = ID_PROPERTY_NAME || 'id';
    this.object = {};
    this.array = [];
  }

  _createClass(EDictionary, [{
    key: "get",
    value: function get(id) {
      var obj = this.object[id];

      if (typeof obj !== 'undefined') {
        return this.object[id];
      }

      return null;
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      for (var i = 0; i < this.array.length; i++) {
        fn(this.array[i], i);
      }
    }
  }, {
    key: "toArray",
    value: function toArray() {
      return this.array;
    }
  }, {
    key: "add",
    value: function add(obj) {
      if (typeof obj === 'object' && typeof obj[this.ID_PROPERTY_NAME] !== 'undefined') {
        this.object[obj[this.ID_PROPERTY_NAME]] = obj;
        this.array.push(obj);
      } else {
        throw new Error('EDictionary could not add object, invalid object or object.id.');
      }
    }
  }, {
    key: "remove",
    value: function remove(obj) {
      if (typeof obj === 'object' && typeof obj[this.ID_PROPERTY_NAME] !== 'undefined') {
        return this.removeById(obj[this.ID_PROPERTY_NAME]);
      } else {//throw new Error('EDictionary could not remove object, invalid object or object.id.')
      }
    }
  }, {
    key: "removeById",
    value: function removeById(id) {
      if (typeof id !== 'undefined') {
        var index = -1;

        for (var i = 0; i < this.array.length; i++) {
          if (this.array[i][this.ID_PROPERTY_NAME] === id) {
            index = i;
            break;
          }
        }

        if (index !== -1) {
          this.array.splice(index, 1);
        } else {//throw new Error('EDictionary could not remove object, id not found.')
        }

        var temp = this.object[id];
        delete this.object[id];
        return temp;
      } else {//throw new Error('EDictionary could not removeById, invalid id.')
      }
    }
  }, {
    key: "size",
    get: function get() {
      return this.array.length;
    }
  }]);

  return EDictionary;
}();

export default EDictionary;